import React, { useEffect } from "react";
import { GeneralTable, useModalAlert } from "../../GeneralComponents";
import { makeStyles } from "@material-ui/core";
import PostAddIcon from "@material-ui/icons/PostAdd";
import history from "../../../history";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function ProfileAdmin() {
  const classes = useStyles();
  const [perfiles, setPerfiles] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const { showModalAlert } = useModalAlert();
  const [openModal, setopenModal] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(false);

  useEffect(() => {
    loadDataProfiles();
  }, [page, pageSize]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const handleCloseModal = () => {
    setopenModal(false);
  };

  const loadDataProfiles = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `perfiles/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setRowCount(data.count);
        const rowsWithId = data.results.map((profile) => ({
          ...profile,
          id: profile.id_perfil, // Creamos una copia del valor en la llave 'id'
        }));

        setPerfiles(rowsWithId);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const newModalField = [
    {
      name: "codigo",
      label: "Código",
      type: "mayuscula",
    },
    { name: "nombre", label: "Nombre del perfil", type: "mayuscula" },
  ];

  const requiredFields = ["codigo", "nombre"];

  const columns = [
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre",
      headerName: "NOMBRE",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const onUpdate = (row) => {};

  const actionsList = [
    {
      title: "Agregar modulo",
      ariaLabel: "view-document",
      icon: <PostAddIcon />,
      onClick: async (row) => {
        history.push({
          pathname: process.env.PUBLIC_URL + "/config/add-modules",
          state: { profile: row },
        });
      },
    },
  ];

  async function handleSavePerfil(formData) {
    try {
      const url = isEditMode
        ? process.env.REACT_APP_PUBLIC_URL + "perfiles/update"
        : process.env.REACT_APP_PUBLIC_URL + "perfiles/create";
      const createResponse = await fetch(url, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(formData),
      });
      const result = await createResponse.json();
      loadDataProfiles();
      setIsEditMode(false);
      handleCloseModal();
      if (isEditMode) {
        showModalAlert("success", "Se actualizo correctamente el perfil");
      } else {
        showModalAlert("success", "Se creo correctamente el perfil");
      }
    } catch (error) {
      showModalAlert("danger", "Error al crear el perfil");
      console.error("Error:", error);
    }
  }

  const onActivate = async (row) => {
    try {
      let dataSend = {
        id_perfil: row.id_perfil,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/habilitar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDataProfiles();
      showModalAlert("success", "Se activo correctamente el perfil");
    } catch {
      showModalAlert("danger", "Error al activar el perfil");
    }
  };

  const onInactivate = async (row) => {
    try {
      let dataSend = {
        id_perfil: row.id_perfil,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/inhabilitar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDataProfiles();
      showModalAlert("success", "Se inactivo correctamente el perfil");
    } catch {
      showModalAlert("danger", "Error al inactivar el rol");
    }
  };

  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Perfil"
        buttonText="Crear Perfil"
        columns={columns}
        rows={perfiles}
        modalFields={newModalField}
        enableActivate
        onActivate={onActivate}
        onInactivate={onInactivate}
        initialFormData={{
          nombre: "",
        }}
        enableUpdate
        onSaveModal={handleSavePerfil}
        actionsList={actionsList}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        /* formData={formData}
        setFormData={setFormData} */
        loadList={loadDataProfiles}
        width={"25%"}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        isModalDocument={true}
        requiredFields={requiredFields}
      />
    </>
  );
}
